function postsCarousel() {
 var $imgSliders = $('.img-slider');

 $imgSliders.each(function() {
     var $this = $(this);
     var itemLength = $this.find('.items').length;
     var windowWidth = $(window).width();

     if (itemLength > 1 && windowWidth < 767) {
         if (!$this.hasClass('owl-carousel')) {
             $this.addClass('owl-carousel').owlCarousel({
                 margin: 10,
                 loop: true,
                 autoWidth: true,
                 items: 1,
                 dots: true,
                 autoHeight: false,
                 mouseDrag: false,
                 touchDrag: true,
                 onResized: function() {
                     if (!this.settings.mouseDrag) {
                         this.$stage.off('mousedown touchstart touchcancel');
                         $(document).off('.owl.dragEvents');
                         this.$stage.get(0).onselectstart = function() {};
                         this.$stage.off('dragstart', function() { return false; });
                     }
                 }
             });
         }
     } else {
         if ($this.hasClass('owl-carousel')) {
             $this.removeClass('owl-carousel').owlCarousel('destroy');
         }
     }
 });
}

jQuery(document).ready(function(){
 postsCarousel();
 $(window).resize(function() {
     postsCarousel();
 });
 jQuery('.back-tops span').on('click',function(){
     var posTop  = jQuery('#history_Timeline').offset();
     jQuery("html, body").stop().animate({
         scrollTop: posTop.top  -  jQuery('.top-header-content').height()
     }, 500);
 });
 jQuery(window).scroll(function() {
     var wW =  jQuery(this).width();

     var heightH = jQuery('.header').height();

     var scrollTop = jQuery(window).scrollTop() + heightH ;

     var top1991 = jQuery('#year_1991').offset();

     if(scrollTop > top1991.top ){
         jQuery('.time-line-year a').removeClass('active');
         jQuery('.time-line-year .year_1991').addClass('active');
     }else {
         jQuery('.time-line-year a').removeClass('active');
     }
     var top1992 = jQuery('#year_1992').offset();
     if(scrollTop > top1992.top ){
         jQuery('.time-line-year a').removeClass('active');
         jQuery('.time-line-year a.year_1992').addClass('active');
     }
     var top2002 = jQuery('#year_2002').offset();
     if( wW > 1023){
         top2002 = top2002.top - 80;
     }else {
         top2002 = top2002.top - 90;
     }
     if(scrollTop > top2002 ){
         jQuery('.time-line-year a').removeClass('active');
         jQuery('.time-line-year a.year_2002').addClass('active');
     }
     var top2006 = jQuery('#year_2006').offset();

     top2006 = top2006.top - 50;

     if(scrollTop > top2006 ){
         jQuery('.time-line-year a').removeClass('active');
         jQuery('.time-line-year a.year_2006').addClass('active');
     }
     var top2012 = jQuery('#year_2012').offset();

     if( wW > 1023){
         top2012 = top2012.top - 125;
     }else {
         top2012 = top2012.top - 70;
     }
     if(scrollTop > top2012 ){
         jQuery('.time-line-year a').removeClass('active');
         jQuery('.time-line-year a.year_2012').addClass('active');
     }
     var top2014 = jQuery('#year_2014').offset();

     if( wW > 1023){
         top2014 = top2014.top - 325;
     }else {
         top2014 = top2014.top - 254;
     }
     if(scrollTop > top2014 ){
         jQuery('.time-line-year a').removeClass('active');
         jQuery('.time-line-year a.year_2014').addClass('active');
     }
     var top2015 = jQuery('#year_2015').offset();
     if( wW > 1023){
         top2015 = top2015.top - 240;
     }else {
         top2015 = top2015.top - 160;
     }
     if(scrollTop > top2015){
         jQuery('.time-line-year a').removeClass('active');
         jQuery('.time-line-year a.year_2015').addClass('active');
     }
     var top2017 = jQuery('#year_2017').offset();

     top2017 = top2017.top - 180;

     if(scrollTop > top2017 ){
         jQuery('.time-line-year a').removeClass('active');
         jQuery('.time-line-year a.year_2017').addClass('active');
     }
     var top2018 = jQuery('#year_2018').offset();
     if( wW > 1023){
         top2018 = top2018.top - 400;
     }else {
         top2018 = top2018.top - 300;
     }
     if(scrollTop > top2018 ){
         jQuery('.time-line-year a').removeClass('active');
         jQuery('.time-line-year a.year_2018').addClass('active');
     }
     var top2019 = jQuery('#year_2019').offset();
     if( wW > 1023){
         top2019 = top2019.top - 1037;
     }else {
         top2019 = top2019.top - 750;
     }
     if(scrollTop > top2019 ){
         jQuery('.time-line-year a').removeClass('active');
         jQuery('.time-line-year a.year_2019').addClass('active');
     }
     var top2020 = jQuery('#year_2020').offset();
     top2020 = top2020.top - 460;
     if(scrollTop > top2020 ){
         jQuery('.time-line-year a').removeClass('active');
         jQuery('.time-line-year a.year_2020').addClass('active');
     }
     jQuery('.time-line-year a').on('click', function() {
        jQuery('.time-line-year a').removeClass('active');
        var nameItem = jQuery(this).attr('class');
        var targetId = nameItem.split(' ')[0]; // Extract the first class
        var $targetYear = jQuery('#' + targetId);
        if ($targetYear.length) {
            var offsetItem = $targetYear.offset().top;
            var wW = jQuery(window).width();
            if (wW > 1023) {
                switch (targetId) {
                    case 'year_2002':
                        offsetItem -= 80;
                        break;
                    case 'year_2006':
                        offsetItem -= 50;
                        break;
                    case 'year_2012':
                        offsetItem -= 125;
                        break;
                    case 'year_2014':
                        offsetItem -= 254;
                        break;
                    case 'year_2015':
                        offsetItem -= 240;
                        break;
                    case 'year_2017':
                        offsetItem -= 180;
                        break;
                    case 'year_2018':
                        offsetItem -= 400;
                        break;
                    case 'year_2019':
                        offsetItem -= 1037;
                        break;
                    case 'year_2020':
                        offsetItem -= 460;
                        break;
                }
            } else {
                switch (targetId) {
                    case 'year_2002':
                        offsetItem -= 90;
                        break;
                    case 'year_2006':
                        offsetItem -= 50;
                        break;
                    case 'year_2012':
                        offsetItem -= 70;
                        break;
                    case 'year_2014':
                        offsetItem -= 325;
                        break;
                    case 'year_2015':
                        offsetItem -= 160;
                        break;
                    case 'year_2017':
                        offsetItem -= 180;
                        break;
                    case 'year_2018':
                        offsetItem -= 300;
                        break;
                    case 'year_2019':
                        offsetItem -= 750;
                        break;
                    case 'year_2020':
                        offsetItem -= 460;
                        break;
                }
            }
            jQuery('html, body').stop().animate({
                scrollTop: offsetItem - jQuery('header.header').height()
            }, 500);
            jQuery(this).addClass('active');
        }
  });

 });
});
